import SectionTitle from 'components/SectionTitle';
import React from 'react';
import preview1 from 'assets/images/Preview 1.png';
import preview2 from 'assets/images/Preview 2.png';
import preview3 from 'assets/images/Preview 3.png';
import preview4 from 'assets/images/Preview 4.png';
import preview5 from 'assets/images/Preview 5.png';
import preview6 from 'assets/images/Preview 6.png';
import preview7 from 'assets/images/Preview 7.png';
import plusCircle from 'assets/icons/PlusCircle.svg';

const Gallery = () => {
  const previews = [
    { handle: '@zyacouri', img: preview1 },
    { handle: '@medyo80', img: preview2 },
    { handle: '@Lina_VLR', img: preview5 },
    { handle: '@zlouly12', img: preview4 },
    { handle: '@hackertabdev', img: preview3 },
    { handle: '@zack_daoudi', img: preview6 },
    { handle: '@CAdbdelilah', img: preview7 }
  ];

  return (
    <section>
      <SectionTitle title="Happy Users" />
      <div className="mt-16 px-6">
        <p className="pb-5 md:p-6 text-lg text-obsidian">
          Bafancy Editor has given some happy users the ability
          <br />
          to make their own Twitter banners.
        </p>
        <div className="flex flex-col justify-center gap-4 md:flex-row md:flex-wrap">
          {previews.map(({ handle, img }, index) => (
            <div
              className="w-full md:w-[30%] transition-all duration-500 hover:-translate-y-2"
              key={index}>
              <a href={`https://twitter.com/${handle}`} target="_blank" rel="noreferrer">
                <img src={img} className="rounded-lg w-full" alt="Twitter banner preview" />
              </a>
            </div>
          ))}
          <a
            href="https://app.bafancy.com"
            className="flex flex-col items-center justify-center w-full md:w-[30%] transition-all duration-500 hover:-translate-y-2 border border-primary border-dashed rounded-md border-spacing-5 p-2 md:p-0">
            <div>
              <img src={plusCircle} className="mx-auto w-6 h-6" alt="" />
              <p className="text-white text-center">
                Be the next
                <br />
                <span className="text-primary">Bafancy</span> family member
              </p>
            </div>
          </a>
        </div>
      </div>
    </section>
  );
};

export default Gallery;
